<mat-toolbar color="primary">
    <mat-toolbar-row>
        {{title}}
        <span class="fill-remaining-space"></span>
    </mat-toolbar-row>
</mat-toolbar>

<router-outlet></router-outlet>
<app-alert></app-alert>

<mat-toolbar color="primary">
    <mat-toolbar-row *ngIf="showButtons">
        <span class="fill-remaining-space"></span>
        <button mat-button class="small" appLink link="/conditions">Terms & Conditions</button>
        <button mat-button class="small" appLink link="/privacy">Privacy</button>
    </mat-toolbar-row>
</mat-toolbar>
